export class TransactionResponseDto {
  public securityWordOfTheDay: string;
}
